import { ExpediaHotelOrigin, ThirdPartyAncillariesProvider } from '@fcom/common';

import { CountryPartnerIdMap, ExpediaLocaleData } from './interfaces/expedia.interface';
import { ExpediaSupportedCountry } from './enums';

export const MANAGE_BOOKING_FEATURE_KEY = 'manage-booking';

export const STATIC_OLD_MMB_POST_PARAMS = {
  SITE: 'FINRFINR',
  PAGE: 'BKGD',
};

const prefix = 'apis-update';
export const OPEN_TRAVEL_PREPARATIONS_NOTIFICATION = `${prefix}_open-travel-preparations-notification`;
export const CANCEL_APIS_UPDATE = `${prefix}-details_apis-cancel`;
export const FULL_APIS_UPDATE = `${prefix}-details-full_apis-success`;
export const PARTIAL_APIS_UPDATE = `${prefix}-details-partial_apis-success`;
export const ERROR_APIS_UPDATE = `${prefix}-details_apis-error`;
export const APIS_REQUIRED = `${prefix}_required`;
export const USER_OTHER_ADDRESS_APIS = `${prefix}-use-other-address_apis`;

export const GTM_BOOKING_WIDGET_ELEMENT_IDS = {
  [ThirdPartyAncillariesProvider.EXPEDIA_HOTEL]: 'booking-widget-tab-button_hotels',
  [ThirdPartyAncillariesProvider.CAR_TRAWLER_RENTAL]: 'booking-widget-tab-button_cartrawler-rental',
};

export const mapToGaString = {
  [ThirdPartyAncillariesProvider.CAR_TRAWLER_RENTAL]: 'third-party-box_cartrawler-rental',
  [ThirdPartyAncillariesProvider.CAR_TRAWLER_TRANSFER]: 'third-party-box_cartrawler-transfer',
  [ThirdPartyAncillariesProvider.EXPEDIA_HOTEL]: 'third-party-box_expedia-hotel',
};

export const mapToGaState = {
  [ThirdPartyAncillariesProvider.CAR_TRAWLER_RENTAL]: 'company: cartrawler',
  [ThirdPartyAncillariesProvider.CAR_TRAWLER_TRANSFER]: 'company: cartrawler',
  [ThirdPartyAncillariesProvider.EXPEDIA_HOTEL]: 'company: expedia',
};

export const carTrawlerSmartBlockConfig = {
  partnerName: 'finnair',
  CTProduct: 'widget',
};

const ENGLISH_EURO: ExpediaLocaleData = { languageCode: 'en_IE', currencyCode: 'EUR' };

export const expediaHotelsWidgetLocales: Record<string, ExpediaLocaleData> = {
  fi_FI: { languageCode: 'fi_FI', currencyCode: 'EUR' },
  en_FI: { languageCode: 'en_GB', currencyCode: 'EUR' },
  de_DE: { languageCode: 'de_DE', currencyCode: 'EUR' },
  en_DE: { languageCode: 'en_GB', currencyCode: 'EUR' },
  de_AT: { languageCode: 'de_DE', currencyCode: 'EUR' },
  de_CH: { languageCode: 'de_DE', currencyCode: 'EUR' },
  en_GB: { languageCode: 'en_GB', currencyCode: 'GBP' },
  en_IE: ENGLISH_EURO,
  sv_SE: { languageCode: 'sv_SE', currencyCode: 'SEK' },
  en_SE: { languageCode: 'en_GB', currencyCode: 'SEK' },
  en_AU: ENGLISH_EURO,
  en_AT: ENGLISH_EURO,
  en_BE: ENGLISH_EURO,
  en_CA: ENGLISH_EURO,
  en_CN: ENGLISH_EURO,
  en_CZ: ENGLISH_EURO,
  en_DK: ENGLISH_EURO,
  en_EE: ENGLISH_EURO,
  en_FR: ENGLISH_EURO,
  en_HK: ENGLISH_EURO,
  en_HU: ENGLISH_EURO,
  en_IS: ENGLISH_EURO,
  en_IN: ENGLISH_EURO,
  en_IL: ENGLISH_EURO,
  en_IT: ENGLISH_EURO,
  en_JP: ENGLISH_EURO,
  en_KR: ENGLISH_EURO,
  en_LV: ENGLISH_EURO,
  en_LT: ENGLISH_EURO,
  en_NL: ENGLISH_EURO,
  en_NO: ENGLISH_EURO,
  en_PL: ENGLISH_EURO,
  en_SG: ENGLISH_EURO,
  en_ES: ENGLISH_EURO,
  en_CH: ENGLISH_EURO,
  en_TH: ENGLISH_EURO,
  en_US: ENGLISH_EURO,
  en: ENGLISH_EURO,
};

export const expediaPartnersConfig: Partial<Record<ExpediaHotelOrigin, CountryPartnerIdMap>> = {
  [ExpediaHotelOrigin.TRIP_OVERVIEW]: {
    [ExpediaSupportedCountry.Finland]: 'Finnair-Ext-Flight-Itin-Rec-Embed',
    [ExpediaSupportedCountry.Germany]: 'Finnair-Ext-Flight-Itin-Rec-Embed-DE',
    [ExpediaSupportedCountry.Ireland]: 'Finnair-Ext-Flight-Itin-Rec-Embed',
    [ExpediaSupportedCountry.UnitedKingdom]: 'Finnair-Ext-Flight-Itin-Rec-Embed',
    [ExpediaSupportedCountry.Sweden]: 'Finnair-Ext-Flight-Itin-Rec-Embed',
  },
  [ExpediaHotelOrigin.THIRD_PARTY_ANCILLARIES]: {
    [ExpediaSupportedCountry.Finland]: 'FinnairDS-Ext-Flight-Itin-Rec-Embed',
    [ExpediaSupportedCountry.Germany]: 'FinnairDS-Ext-Flight-Itin-Rec-Embed-DE',
    [ExpediaSupportedCountry.Ireland]: 'FinnairDS-Ext-Flight-Itin-Rec-Embed',
    [ExpediaSupportedCountry.UnitedKingdom]: 'FinnairDS-Ext-Flight-Itin-Rec-Embed',
    [ExpediaSupportedCountry.Sweden]: 'FinnairDS-Ext-Flight-Itin-Rec-Embed',
  },
  [ExpediaHotelOrigin.ANCILLARY_CONFIRMATION]: {
    [ExpediaSupportedCountry.Finland]: 'finnair-finland-external-conf',
    [ExpediaSupportedCountry.Germany]: 'finnair-germany-external-conf',
    [ExpediaSupportedCountry.Ireland]: 'finnair-ireland-external-conf',
    [ExpediaSupportedCountry.UnitedKingdom]: 'finnair-uk-external-conf',
    [ExpediaSupportedCountry.Sweden]: 'finnair-sweden-external-conf',
  },
};
